{
  "version": 1,
  "asset_id": "bab8e5e5-21b5-4e96-8287-00e5d3045b0f",
  "project_id": "1820e758-46fa-46b0-bd5a-016534d0d263",
  "url": "/__l5e/assets-v1/bab8e5e5-21b5-4e96-8287-00e5d3045b0f/home-hero-v2-640.webp",
  "r2_key": "a/v1/1820e758-46fa-46b0-bd5a-016534d0d263/bab8e5e5-21b5-4e96-8287-00e5d3045b0f/home-hero-v2-640.webp",
  "original_filename": "home-hero-v2-640.webp",
  "size": 15700,
  "content_type": "image/webp",
  "created_at": "2026-10-10T12:40:10Z"
}
